// extracted by mini-css-extract-plugin
export var lg = "_2o-4";
export var md = "_2o-3";
export var sm = "_2o-2";
export var xs = "_2o-1";
export var xxs = "_2o-0";